<template>
  <div>
    <div v-if="modal">
      <div class="modal-pdv" id="modalDetalhes" tabindex="-1" :class="{'show': modal === 1}">
        <div class="modal-pdv-content modal-large pt-0">
          <div class="height-100 pt-3">
            <div class="container-fluid">
              <loading v-show="load"/>
              <div class="row" v-show="!load">
                <div class="col-md-6 mb-2">
                  <div class="p-1 mb-2" v-if="dados.produto.url_imagem">
                    <img :src="dados.produto.url_imagem" class="rounded" style="height: 120px; width: 100%; object-fit: cover">
                  </div>
                  <div class="row no-gutters">
                    <div class="col-12">
                      <div v-if="dados.produto.id_medida === '1'">
                        <div class="mb-2">
                          <label class="mb-0">Quantidade</label>
                          <div class="border p-2 rounded">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="w-100" style="font-weight: bold; padding: 6px">
                                <input class="form-control" type="number" :id="id + 'qtd'"
                                       v-model="dados.quantidade" min="1" @change="totalizar" @keyup.enter="atualizarProduto()">
                              </div>
                              <div class="text-right text-nowrap">
                                <button class="btn btn-info px-4 mr-1" @click="minusQtd()">
                                  <i class="fa fa-minus"></i>
                                </button>
                                <button class="btn btn-info px-4" @click="plusQtd()">
                                  <i class="fa fa-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="alert alert-info mb-2" v-if="estoque && estoque.qtd">
                          <span>Estoque: <b>{{estoque.qtd | percent}}</b></span>
                        </div>
                        <div class="mb-2" v-if="dados.produto && !dados.divisoes.length">
                          <label class="mb-0">Valor Unitário</label>
                          <div class="d-flex justify-content-between">
                            <money class="form-control mr-2"
                                   :id="id + 'unitario'"
                                   :edit="editar"
                                   v-model="dados.produto.valor"
                                   @keyup.enter.native="atualizarProduto"
                                   @focus.native="$helpers.selectElement(id + 'unitario')"
                                   @blur.native="totalizar()" :disabled="!editar"/>
                            <button v-if="!editar" class="btn btn-third" style="width: 62px" @click="editarValor()"><i class="fa fa-edit"></i></button>
                          </div>
                        </div>
                      </div>
                      <div class="mb-2" v-else>
                        <label class="mb-0">Valor</label>
                        <div class="d-flex justify-content-between">
                          <money class="form-control" v-model="valorProduto"/>
                          <button :disabled="valorProduto <= 0" class="btn btn-third px-4 ml-2" @click="inserirKilo">Alterar</button>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 mb-2" v-if="dados.produto.id_medida !== '2'">
                      <label class="mb-0">Desconto</label>
                      <div class="d-flex justify-content-between">
                        <money v-model="desconto" class="form-control mr-2" placeholder="Desconto do Produto"
                               @keyup.enter.native="inserirDesconto()"
                               :disabled="dados.desconto > 0"/>
                        <button class="btn btn-third" style="width: 62px" @click="inserirDesconto">
                          <i class="fa fa-plus" v-show="dados.desconto <= 0"></i>
                          <i class="fa fa-trash-alt" v-show="dados.desconto > 0"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-12 mb-2">
                      <label class="mb-0" for="observacoes">Observações</label>
                      <textarea id="observacoes" class="form-control" rows="2" style="resize: none" placeholder="Observações do produto" v-model="dados.observacao"></textarea>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="border rounded px-2 mb-2">
                    <div>
                      <div class="py-2 border-bottom">
                        <b>{{dados.produto.nome_produto}}</b>
                        <div v-for="d in dados.divisoes">
                          # {{d.nome_produto}}
                        </div>
                      </div>
                      <div class="d-flex justify-content-between pt-2">
                        <div>Qtd:</div>
                        <div>
                          <span v-show="dados.produto.id_medida === '1'">{{dados.quantidade | fixed}}</span>
                          <span v-show="dados.produto.id_medida !== '1'">{{dados.quantidade | medida}}</span>
                        </div>
                      </div>
                      <div class="d-flex justify-content-between">
                        <div>{{dados.produto.id_medida === '2' ? 'Valor/kg' : 'Valor' }}:</div>
                        <div>R$ {{ dados.produto.valor | valor }}</div>
                      </div>
                      <div class="d-flex justify-content-between" v-show="dados.adicionais.length > 0">
                        <div>Adicionais:</div>
                        <div>(+) R$ {{valorAdicionais * dados.quantidade | valor}}</div>
                      </div>
                      <div class="d-flex justify-content-between pb-2 border-bottom">
                        <div>Desconto:</div>
                        <div>(-) R$ {{dados.desconto | valor}}</div>
                      </div>
                      <div class="d-flex justify-content-between py-2">
                        <div>Total:</div>
                        <div class="font-weight-bold">R$ <span>{{dados.valor_total | valor}}</span></div>
                      </div>
                    </div>
                  </div>
                  <button class="btn btn-info btn-block text-left py-3 mb-lg-3" @click="openAdicionais">
                    <i class="fa fa-th"></i>
                    <span class="d-block small">Adicionais</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-content-footer bg-light border-top p-2 d-flex justify-content-between">
            <button class="btn btn-dark p-3" @click="toggleModal(0)">
              <i class="fa fa-chevron-left"></i> Voltar
            </button>
            <button class="btn btn-success p-3" @click="atualizarProduto()" v-if="!disabled">
              <i class="fa fa-edit"></i> Concluir
            </button>
          </div>
        </div>
      </div>
    </div>
    <adicionais ref="addDetalhes" @voltar="voltar" @retornar="atualizarAdicionais" :disabled="disabled"/>
  </div>
</template>

<script>
  import Adicionais from "./Adicionais";
  import Loading from "@/components/commons/Loading";

  export default {
    name: "DetalhesProduto",
    components: {Loading, Adicionais},
    props: ['comanda', 'disabled','pedido'],
    data() {
      return {
        load: false,
        id: this.$helpers.ID(),
        modal: 0,
        token: localStorage.getItem('key'),
        pedidos: [],
        produto: '',
        desconto: 0,
        estoque: null,
        editar: false,

        dados: {
          produto: {
            adicionais: []
          },
          divisoes: [],
          adicionais: []
        },

        valorProduto: 0,
        valorAdicionais: 0,

        money: {
          decimal: '.',
          thousands: '',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        }
      }
    },

    methods: {
      toggleModal(n, callback) {
        this.modal = n;
        this.$nextTick(() => {
          this.$helpers.toggleModal(n, 'modalDetalhes', this.toggleModal);
          if (n) {
            if (callback) {
              callback();
            }

          } else {
            this.$emit('voltarDetalhes');
          }
        });
      },

      atualizarProduto() {
        this.totalizar();

        if (this.dados.valor_total < 0) {
          this.$swal("O valor total não pode ser menor que zero!")
          return;
        }

        if (this.dados.quantidade <= 0) {
          this.$swal("Selecione uma quantidade válida!")
          return;
        }

        if (this.estoque && this.dados.quantidade >= this.estoque.qtd) {
          this.$swal("Estoque máximo permitido: " + this.estoque.qtd.toFixed()).then(() => {
            this.$helpers.selectElement(this.id + 'qtd');
          });

          return;
        }

        if (this.pedido) {
          this.$emit('atualizarProduto', this.dados, true);
          this.toggleModal(0);

        } else if (!this.dados.produto.id_comanda_produto) {
          this.$emit('atualizar', this.dados);
          this.toggleModal(0);

        } else if (this.comanda && this.comanda.id_comanda) {
          this.$helpers.confirmarSenhaAdm(this, () => {
            this.atualizarProdutoServidor();
          });
        }
      },

      atualizarProdutoServidor() {
        let dados = {
          comanda: {
            id_comanda: this.comanda.id_comanda,
            id_comanda_produto: this.dados.produto.id_comanda_produto || null
          }
        };

        this.load = true;
        let base = "pdv/produtos/editar/" + this.token;
        let p = Object.assign(this.dados, dados);
        this.$store.state.load = 'Editando produto';

        if (this.id_catalogo) {
          p.id_catalogo = this.id_catalogo;
        }

        this.$http.post(base, p)
          .then(res => {
            this.load = false;
            this.$store.state.load = false;
            this.$emit('atualizarVenda');
            this.toggleModal(0);

          }, res => {
            console.log(res);
            this.$store.state.load = false;
            this.load = false;
            this.$swal(res.data.msg);
          });
      },

      editarProduto(dados) {
        this.toggleModal(1, () => {
          this.dados = JSON.parse(JSON.stringify(dados));
          this.valorProduto = parseFloat(this.dados.valor_total);
          this.dados.quantidade = dados.quantidade ? parseFloat(dados.quantidade) : 1;
          this.desconto = this.dados.desconto || 0;
          this.editar = this.dados.id_tabela_preco === "REF001";

          if (this.comanda && this.comanda.id_comanda && this.dados.adicionais && this.dados.adicionais.length) {
            this.dados.adicionais.forEach((adc) => {
              adc.quantidade = (adc.quantidade / this.dados.quantidade).toFixed();
            });
          }

          this.totalizar();

          if (this.req_estoque && dados.id_tabela_preco !== 'REF001') {
            this.consultarEstoque(dados.produto.id_tabela_preco);

          } else {
            this.$nextTick(() => {
              this.$helpers.selectElement(this.id + 'qtd');
            });
          }
        });
      },

      consultarEstoque(id) {
        this.load = true;
        this.estoque = null;
        const params = { id, id_catalogo: this.id_catalogo }
        this.$http.get('produto/estoque/preco/' + this.token, { params })
          .then(response => {
            this.load = false;
            this.estoque = response.data || null;

            if (this.estoque) {
              this.estoque.qtd = parseInt(this.estoque.qtd) + (this.dados.produto.id_comanda_produto ? this.dados.quantidade : 0);
            }

            this.$nextTick(() => {
              this.$helpers.selectElement(this.id + 'qtd');
            });

          }, res => {
            this.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          })
      },

      inserirDesconto() {
        if (this.desconto <= 0) {
          return;
        }

        if (this.dados.desconto > 0) {
          this.dados.desconto = 0;
          this.desconto = 0;
          this.totalizar();

        } else if (this.desconto > this.dados.valor_total) {
          this.desconto = 0;
          this.$swal("O valor do desconto não pode ser maior que o total do produto!")

        } else {
          this.$helpers.confirmarSenhaAdm(this, () => {
            this.dados.desconto = this.dados.desconto > 0 ? 0 : this.desconto;
            this.desconto = this.dados.desconto > 0 ? this.desconto: 0;
            this.totalizar();
          });
        }
      },

      inserirKilo() {
        this.dados.quantidade = (this.valorProduto / this.dados.produto.valor).toFixed(3);
        this.dados.valor_total = parseFloat(this.valorProduto);
      },

      plusQtd() {
        if (this.estoque && this.dados.quantidade >= this.estoque.qtd) {
          this.$swal("Estoque máximo: " + this.estoque.qtd.toFixed());
          return;
        }

        this.dados.quantidade++;
        this.totalizar()
      },

      minusQtd() {
        if (this.dados.quantidade > 1 && this.desconto > ((this.dados.quantidade - 1) * this.dados.produto.valor)) {
          this.$swal("Atenção","Para diminuir a quantidade, remova o desconto.");
          return;
        }

        if (this.dados.quantidade > 1) {
          this.dados.quantidade--;
        }

        this.totalizar();
      },

      editarValor() {
        this.$helpers.confirmarSenhaAdm(this, () => {
          this.$helpers.focusElement(this.id + 'unitario');
          this.editar = true;
        });
      },

      totalizar() {
        let valor = parseFloat(this.dados.produto.valor);

        // if (this.dados.divisoes.length > 0) {
        //   valor = this.dados.produto.tipo_venda === '2' ?
        //       (this.dados.divisoes.map(d => parseFloat(d.valor)).reduce((prev, curr) => prev + curr, 0) / this.dados.divisoes.length)
        //       : Math.max.apply(Math, this.dados.divisoes.map(d => { return d.valor; }));
        // }

        this.valorAdicionais = 0;
        this.dados.adicionais.forEach((a) => {
          this.valorAdicionais += (a.valor * a.quantidade)
        });

        if (this.dados.produto.id_medida === '2') {
          this.dados.valor_total = parseFloat(this.dados.valor_total) + this.valorAdicionais - this.dados.desconto;

        } else {
          this.dados.valor_total = ((valor + this.valorAdicionais) * this.dados.quantidade) - this.dados.desconto;
        }
      },

      openAdicionais() {
        this.$refs.addDetalhes.editarAdicionais(JSON.parse(JSON.stringify(this.dados)));
      },

      atualizarAdicionais(adicionais) {
        if (!this.comanda || this.comanda.status === '1') {
          this.modal = 1;
          this.dados.adicionais = adicionais.map(a => { return {
            id_comanda_produto: a.id_comanda_produto || null,
            id_grupo_adicional: a.id_grupo_adicional,
            id_tabela_preco: a.id_tabela_preco,
            nome_produto: a.nome_produto,
            quantidade: a.quantidade,
            valor_custo: a.valor_custo || 0,
            valor: a.valor
          }});

          this.totalizar()
        }

        if (this.dados.valor_total < 0) {
          this.inserirDesconto();
        }
      },

      voltar() {
        this.modal = 1;
        this.$nextTick(() => {
          this.$helpers.selectElement(this.id + 'qtd')
        })
      }
    },

    created() {
      this.$parent.$on('editarProduto', (p) => {
        this.editarProduto(p);
      });
    },

    computed: {
      id_catalogo() {
        return this.$store.state.id_catalogo;
      },

      req_estoque() {
        return this.$store.state.req_estoque;
      }
    },

    filters: {
      fixed(value) {
        if (value !== null || value !== undefined) {
          return parseFloat(value).toFixed();
        }
      },

      medida(value) {
        if (value !== null || value !== undefined) {
          return parseFloat(value).toFixed(3) + " kg";
        }
      },

      valor(value) {
        if (value !== null || value !== undefined) {
          return parseFloat(value).toFixed(2);
        }
      }
    }

  }
</script>

<style scoped>
  .pdivisoes:after {
    content: ' / ';
    font-weight: bold;
  }

  .pdivisoes:last-child:after {
    content: '';
  }

  th {
    padding: 0;
  }

</style>
